export default "__VITE_ASSET__B9pVYIZ0__"